export default {
  deposit: {
    title: '保证金管理',
    depositNo: '保证金编号',
    merchant: '商户',
    merchantName: '商户名称',
    contractNo: '合同编号',
    depositType: '保证金类型',
    sourceType: '来源',
    sourceNo: '来源单号',
    totalAmount: '保证金总额',
    deductedAmount: '已扣金额',
    refundedAmount: '已退金额',
    balance: '可用余额',
    status: '状态',
    receiveDate: '收缴日期',
    receiveMethod: '收款方式',
    receiveVoucher: '收款凭证',
    receiptNo: '收据号',
    remark: '备注',
    isIntention: '是否意向金',
    convertedToContract: '已转正式合同',

    // 类型
    type: {
      RENT_DEPOSIT: '租赁押金',
      PROPERTY_DEPOSIT: '物业押金',
      RENOVATION_DEPOSIT: '装修保证金',
      UTILITY_DEPOSIT: '水电押金',
      INTENTION_DEPOSIT: '意向金'
    },

    // 来源
    source: {
      CONTRACT: '合同签约',
      RENOVATION: '装修进场',
      UTILITY: '水电预缴',
      INTENTION: '意向签约',
      MANUAL: '手工录入'
    },

    // 状态
    statusName: {
      PENDING: '待收',
      COLLECTED: '已收',
      DEDUCTING: '扣款中',
      REFUNDING: '退款中',
      REFUNDED: '已退',
      CLOSED: '已结清'
    },

    // 收款方式
    paymentMethods: {
      BANK_TRANSFER: '银行转账',
      CASH: '现金',
      CHECK: '支票',
      OTHER: '其他'
    },

    // 操作
    action: {
      receive: '收款确认',
      deduct: '发起扣款',
      refund: '发起退款',
      offsetApply: '申请抵扣',
      convert: '意向金转正',
      approve: '审批通过',
      reject: '审批驳回',
      execute: '执行操作',
      cancel: '取消操作',
      viewDetail: '查看详情',
      printReceipt: '打印收据'
    },

    // 记录类型
    recordType: {
      RECEIVE: '收缴',
      DEDUCT: '扣款',
      REFUND: '退款',
      CONVERT: '转换',
      OFFSET: '抵扣申请'
    },

    // 原因类型
    reasonType: {
      ARREARS: '欠费抵扣',
      BREACH: '违约扣款',
      DAMAGE: '损坏赔偿',
      NORMAL: '正常退款',
      OTHER: '其他'
    },

    // 凭证类型
    voucherType: {
      CONTRACT_CLAUSE: '合同条款',
      ARREARS_RECORD: '欠费记录',
      BREACH_PHOTO: '违约照片',
      DAMAGE_PHOTO: '损坏照片',
      PAYMENT_VOUCHER: '打款凭证',
      REFUND_VOUCHER: '退款凭证',
      RECEIVE_VOUCHER: '收款凭证',
      OTHER: '其他'
    },

    // 统计
    summary: {
      pending: '待收缴',
      collected: '已收缴',
      processing: '处理中',
      deducting: '扣款中',
      refunding: '退款中',
      completed: '已完成',
      total: '合计',
      countUnit: '笔'
    },

    // 表单
    form: {
      amount: '金额',
      reasonType: '原因类型',
      reason: '说明',
      relatedBill: '关联账单',
      voucher: '凭证文件',
      targetDepositType: '转换类型',
      bankAccount: '收款账户',
      executeVoucher: '执行凭证'
    },

    // 提示
    tip: {
      noBalance: '可用余额不足',
      hasArrears: '商户存在欠费，请先处理',
      uploadVoucher: '请上传至少一个凭证文件',
      confirmReceive: '确认收款后将生成收据，是否继续？',
      confirmExecute: '确认执行后将从保证金中扣除相应金额，是否继续？'
    },

    // 标题
    pageTitle: {
      list: '保证金列表',
      detail: '保证金详情',
      receive: '收款确认',
      deduct: '发起扣款',
      refund: '发起退款',
      offset: '申请抵扣',
      convert: '意向金转正',
      timeline: '操作记录'
    }
  }
}
